import { CheckboxField } from '@petsmart-ui/sparky';
import { useField, useFormikContext } from 'formik';

import type { AddPaymentFormInterface, EditPaymentFormInterface } from './schema';

export function IsDefaultCheckbox({ disabled = false }: { readonly disabled: boolean }) {
    const [{ value }] = useField<boolean>('isPrimary');
    const { setFieldValue } = useFormikContext<AddPaymentFormInterface | EditPaymentFormInterface>();
    return (
        <CheckboxField className="sparky-u-margin-bottom-lg " hideLegend label="Default payment method checkbox">
            <CheckboxField.Item
                text="Set as default payment method"
                name="isPrimary"
                checked={value}
                onChange={value => setFieldValue('isPrimary', value)}
                disabled={disabled}
            />
        </CheckboxField>
    );
}
